import {useLazyQuery } from '@apollo/client'
import React, {useEffect, useState, MouseEventHandler} from 'react'
import {GET_PRODUCT_BY_FILTER} from '../../../../../utils/GraphQLAPI'
import '../../../../shared-css/tagify.css'

import Select, {
  components,
  MultiValueProps,
  OnChangeValue,
  Props,
} from 'react-select';

import {
  SortableContainer,
  SortableContainerProps,
  SortableElement,
  SortEndHandler,
} from 'react-sortable-hoc';
import { arrayMove } from '../../../../../utils/helper';

interface PropsValue {
  formik : any,
  salesDatas : any
  label: any
  isEdit : boolean
  salesProducts : any
}

const SortableMultiValue = SortableElement(
  (props: MultiValueProps<any>) => {
    // this prevents the menu from being opened/closed when the user clicks
    // on a value to begin dragging it. ideally, detecting a click (instead of
    // a drag) would still focus the control and toggle the menu, but that
    // requires some magic with refs that are out of scope for this example
    const onMouseDown: MouseEventHandler<HTMLDivElement> = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const innerProps = { ...props.innerProps, onMouseDown };
    return <components.MultiValue {...props} innerProps={innerProps} />;
  }
);

const SortableSelect = SortableContainer(Select) as React.ComponentClass<
  Props<ColourOption, true> & SortableContainerProps
>;

export interface ColourOption {
  readonly value: string;
  readonly label: string;
  readonly color: string;
  readonly isFixed?: boolean;
  readonly isDisabled?: boolean;
}

const productSetup = (product:any) => {
  return {
    id: product.prod_id,
    value: product.prod_id,
    label: product.prod_name,
    name: product.prod_name,
    __typename: 'ProductsByFilter'
  }
}
const ProductDetails = ({ formik, salesDatas, label, isEdit, salesProducts}: PropsValue) => {
  const [chooseProducts, setChooseProducts] = useState<any>([])
  const [serverProductId, setServerProductId] = useState<any>([]);

  useEffect(()=>{
    if(salesDatas && salesDatas.products && salesDatas.products.length > 0){
      const products = salesDatas.products;
      const productIds = products.map((product:any) => productSetup(product));
      setServerProductId(productIds)
      setSelected(productIds)
      setSelectedId([]);
    }

    if (!salesProducts) {
      getProductDetails()
    } else {
      setChooseProducts(salesProducts.map((product:any) => productSetup(product)));
    }
  },[salesDatas, isEdit])

  const [selected, setSelected] = useState<any>([]);
  const [removedId, setRemovedId] = useState<any>([])

  const [selectedId, setSelectedId] = useState<any>([])

  const onChange = (selectedOptions: OnChangeValue<any,true>, actionType:any) =>{
    setSelected(selectedOptions);
    if(actionType.action === "select-option"){
      if(serverProductId.length === 0 || serverProductId.some((item:any) => item.id !== actionType.option.id)){
        const getSelectedId = selectedId;
        getSelectedId.push(actionType.option.id);
        setSelectedId(getSelectedId)
        formik.setFieldValue("productIds",getSelectedId);
      }
     } else if(actionType.action === "remove-value") {
      //allow the id should already in serverId when we remove
      if(serverProductId.some((item:any) => item.id === actionType.removedValue.id)){
        const getRemovedIds = removedId;
        getRemovedIds.push(actionType.removedValue.id)
        setRemovedId(getRemovedIds)
        formik.setFieldValue("deletedProductId", getRemovedIds);
      }
      if(selectedId.includes(actionType.removedValue.id)){
        const filteredArray = selectedId.filter((e:any, index:any) => {
          return e !== actionType.removedValue.id && selectedId.indexOf(e) === index 
        })
        formik.setFieldValue("productIds", filteredArray)
        setSelectedId(filteredArray)
      }

    }else if(actionType.action === "clear"){
      setRemovedId(actionType.removedValues.map((item:any) =>  item.id || item.value ))
      formik.setFieldValue("deletedProductId", actionType.removedValues.map((item:any) =>  item.id || item.value ));
    }
  }

  const onSortEnd: SortEndHandler = ({ oldIndex, newIndex }) => {
    const newValue = arrayMove(selected, oldIndex, newIndex);
    setSelected(newValue);
  };

  const [getProductDetails] = useLazyQuery(GET_PRODUCT_BY_FILTER, {
    fetchPolicy: 'network-only',
    onCompleted: (data: any) => {
      if (formik.touched.utility || formik.touched.commodity || formik.touched.customerType){
        setChooseProducts(
          data?.getProductByFilter?.map((x: any) => ({
            ...x,
          }))
        )
      } else {
        setChooseProducts(data?.getProductByFilter)
      }
    },
    variables: {
      salesChannelProductInput: {
        commodityId: formik.getFieldMeta('commodityId').value,
        customerTypeId: formik.getFieldMeta('customerTypeId').value,
        utilityId: formik.getFieldMeta('utilityId').value,
      },
    },
  })
  return (
    <>
      <label className='d-flex align-items-center mb-2'>
        <span className='fs-6 fw-semibold lh-23px'>
          {label}
        </span>
      </label>

      <SortableSelect
        maxMenuHeight={170}
        useDragHandle
        // react-sortable-hoc props:
        axis="xy"
        isDisabled = {isEdit}
        onSortEnd={onSortEnd}
        distance={4}
        // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
        getHelperDimensions={({ node }) => node.getBoundingClientRect()}
        // react-select props:
        isMulti
        options={chooseProducts.map((channelName: any) => {
          return {
            id: channelName.id,
            value: channelName.id,
            label: channelName.name,
            name: channelName.name,
            __typename: 'SalesChannel',
          }
        })}
        value={selected}
        onChange={onChange}
        components={{
          // @ts-ignore We're failing to provide a required index prop to SortableElement
          MultiValue: SortableMultiValue,
          //MultiValueLabel: SortableMultiValueLabel,
        }}
        closeMenuOnSelect={false}
      />
    </>
  )
}

export default ProductDetails
